var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow"},[_c('h2',[_c('a'),_vm._v("表格相关")]),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("默认排序/自定义排序")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("表格行权限")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("表格列权限")])])])])])
}]

export { render, staticRenderFns }